import { useState } from 'react';
import { useFormikContext } from 'formik';

import { TabsUI } from '../Interface';
import SupportingDocumentTypeReports from './SupportingDocumentTypeReports';

const SupportingDocumentTypeTabs = (props) => {
  const [activeTab, setActiveTab] = useState(0);
  const { values } = useFormikContext();

  if (!values.generated) return null;

  const tabs = [
    {
      id: 0,
      name: 'Riportmellékletek',
      content: <SupportingDocumentTypeReports {...props} />,
    },
  ];

  return (
    <div className="my-4 mt-6">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={setActiveTab}>
          {tabs.map((tab) => (
            <div key={tab.id} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
    </div>
  );
};

export default SupportingDocumentTypeTabs;
